const routers = [
    {
        path: '/fabric',
        name: 'fabric',
        meta: {
            exp: '灵感面料',
            requireAuth: false
        },
        component: () => import('@/views/fabric/index.vue'),
    },
    {
        path: '/fabric_detail',
        name: 'fabric_detail',
        meta: {
            exp: '灵感面料详情',
            requireAuth: false
        },
        component: () => import('@/views/fabric/fabric_detail/index.vue'),
    }
]
export default routers